import React from "react";

const BackHead = () => {
  return (
    <div className="faceHeaderContainer">
      <h1>
        Discover Top-Notch Body Back Waxing, De-tan & Threading in Bangalore
      </h1>
      <p>
        Are you ready to elevate your grooming routine? Look no further than
        Body Back Waxing, De-tan & Threading in Bangalore. This trifecta of
        beauty treatments is designed to transform your skin, giving you a
        smooth, radiant, and polished look. At SCENT, we offer unparalleled
        expertise and premium services that cater to all your grooming needs.
        Let us guide you through the benefits and offerings of Body Back Waxing,
        De-tan & Threading in Bangalore to help you make an informed choice for
        your beauty regimen.
      </p>
    </div>
  );
};

export default BackHead;
